import { render } from "./ContactView.vue?vue&type=template&id=9aa97eaa&scoped=true"
const script = {}

import "./ContactView.vue?vue&type=style&index=0&id=9aa97eaa&scoped=true&lang=css"

import exportComponent from "/home/runner/work/nexascale/nexascale/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9aa97eaa"]])

export default __exports__